export enum PermissionTypeEnum {
  MANAGE_USERS = 'MANAGE_USERS',
  MANAGE_STORES = 'MANAGE_STORES',
  REPORTS = 'REPORTS',
  MAKE_PAYMENTS = 'MAKE_PAYMENTS',
  READ_BILLINGS='READ_BILLINGS'
}
